<div class="h-1 border-b border-gray-200" *ngIf="!showSelectedItems">
    <mat-progress-bar *ngIf="!loaded" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex items-center py-4 pl-2 border-b" *ngIf="showSelectedItems">
    <button class="mr-1" mat-icon-button (click)="hideSelectedItemsPanel()">
        <em class="ti ti-arrow-narrow-left icon-size-7 text-gray-500"></em>
    </button>
    <div class="ml-1 flex items-center">
        <span class="text-lg">{{'dataPicker.customer.selected_customer' | translate}}</span>
        <badge class="ml-2" [options]="getBadgeOptions()">
        </badge>
    </div>
</div>
<ul role="list" class="divide-y divide-gray-200 overflow-y-auto zuper-scrollbar data-picker-list-content-height" [ngClass]="{ 'data-picker-max-count': isMaxSelectionLimit }"
    *ngIf="customers.length">
    <li class="customer-data-picker-list-ele" *ngFor="let customer of customers;let index = index">
        <div class="hover:bg-gray-50 group relative flex items-center py-3 px-5 w-full"
            [ngClass]="{'cursor-pointer': selectOption === 'readOnly'}"
            (click)="selectOption === 'readOnly' ? viewCustomerDetails($event, customer.customer_uid) : null">
            <a class="-m-1 block flex-1 p-1 picker-data-parent-container">
                <div class="relative flex min-w-0 flex-1 items-center">
                    <div class="picker-data-inner-container flex" *ngIf="selectOption === 'multiSelect'">
                        <span class="flex items-center flex justify-center px-1">
                            <input type="checkbox" class="picker-data-selection-size" id="customer_data_select_{{index}}" (change)="selectCustomer($event, customer)" [checked]="isSelectedCustomer(customer)"
                                [disabled]="validateSelectionDisable(customer)"
                                [matTooltip]="validateSelectionDisable(customer) ?
                                                                selectionDisable?.tooltipText ?  selectionDisable?.tooltipText : ('text.datapicker.customer.selection_disable' | translate) : null" />
                        </span>
                        <div class="ml-4 truncate picker-data-value-content">
                            <ng-container *ngTemplateOutlet="customersContent"></ng-container>
                        </div>
                    </div>
                    <div class="picker-data-inner-container flex" *ngIf="selectOption === 'select'">
                        <span class="flex items-center flex justify-center px-1">
                        <input type="radio" class="picker-data-selection-size" id="customer_data_select_{{index}}" (change)="selectCustomer($event, customer)" [checked]="isSelectedCustomer(customer)"
                            [disabled]="validateSelectionDisable(customer)"
                            [matTooltip]="validateSelectionDisable(customer) ? 
                                            selectionDisable?.tooltipText ? selectionDisable?.tooltipText : ('text.datapicker.customer.selection_disable' | translate) : null" />
                        </span>
                        <div class="ml-4 truncate picker-data-value-content">
                            <ng-container *ngTemplateOutlet="customersContent"></ng-container>
                        </div>
                    </div>
                    <ng-container *ngIf="selectOption === 'readOnly'">
                        <div class="ml-2 truncate picker-data-value-content">
                            <ng-container *ngTemplateOutlet="customersContent"></ng-container>
                        </div>
                    </ng-container>
                    <ng-template #customersContent>
                    <div class="w-full flex flex-col">
                        <label class="truncate text-lg font-medium text-gray-900 cursor-pointer" for="customer_data_select_{{index}}">
                            {{customer.customer_first_name}}
                            {{customer.customer_last_name ?? ''}}
                        </label>
                        <label *ngIf="customer.customer_email" class="truncate text-base text-gray-500">
                            {{customer.customer_email}}
                        </label>
                    </div>
                    </ng-template>
                    <button mat-icon-button class="cursor-pointer ml-auto"
                        matTooltip="{{ updateArrowTooltipText(customer.customer_uid) | translate }}" matTooltipPosition="left"
                        *ngIf="!showSpinLoading(customer.customer_uid)" [ngClass]="rotateArrowIcon(customer.customer_uid)"
                        (click)="viewCustomerDetails($event, customer.customer_uid)">
                        <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                            data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down" width="24"
                                height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none">
                                </path>
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </mat-icon>
                    </button>
                    <div class="ml-auto py-2.5 h-10" *ngIf="showSpinLoading(customer.customer_uid)">
                        <mat-spinner class="ml-auto data-picker-spinner md:mr-3" [diameter]="18" style="width: 18px;height: 18px">
                        </mat-spinner>
                    </div>
                </div>
            </a>
        </div>
        <div class="p-4 bg-gray-100"
            *ngIf="('customer_details_' + customer.customer_uid === customerEleId) && customerDetails && !isSpinLoading">
            <div class="bg-card rounded relative">
                <a target="_blank" class="hidden" #viewFullDetails
                    href="{{viewCustomerFullDetails(customer.customer_uid)}}"></a>
                <span class="cursor-pointer absolute right-0 pt-1 pr-1 z-50" (click)="viewFullDetails.click($event)"
                    matTooltip="{{'text.view_details.new_tab' | translate}}"
                    matTooltipPosition="left">
                    <button mat-icon-button>
                        <mat-icon class="text-xl">open_in_new</mat-icon>
                    </button>
                </span>
                <div class="text-base">
                    <div class="px-2 truncate flex flex-wrap">
                        <div *ngIf="customerDetails.customer_company_name || (customerDetails.customer_organization && customerDetails.customer_organization?.organization_name)"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer customer-details-fields dark:bg-hover flex-item-wrap">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'text.organization' | translate}}</p>
                                <div *ngIf="customerDetails.customer_organization?.organization_name; else customerCompanyName">
                                    <p class="mt-1 text-gray-900"
                                        *ngIf="customerDetails.customer_organization?.is_deleted === true || !utilityService.hasModuleAccess('ORGANIZATION')">
                                        {{customerDetails.customer_organization?.organization_name
                                        }}</p>
                                    <p class="mt-1"
                                        *ngIf="customerDetails.customer_organization?.organization_name && !customerDetails.customer_organization.is_deleted && utilityService.hasModuleAccess('ORGANIZATION')">
                                        <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                            [routerLink]="utilityService.getLink('ORGANIZATION', customerDetails.customer_organization.organization_uid)">
                                            {{customerDetails.customer_organization?.organization_name}}</a>
                                    </p>
                                </div>
                                <ng-template #customerCompanyName>
                                    <p class="mt-1 text-gray-900">
                                        {{customerDetails.customer_company_name
                                        }}</p>
                                </ng-template>
                        </div>
                        <div *ngIf="customerDetails.customer_category && customerDetails.customer_category.category_name"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer customer-details-fields dark:bg-hover flex-item-wrap">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'text.customer_category' | translate}} </p>
                            <p class="mt-1 text-gray-900">
                                {{customerDetails.customer_category.category_name}}</p>
                        </div>
                        <div *ngIf="customerDetails.customer_timezone_value"
                        class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer customer-details-fields dark:bg-hover flex-item-wrap">
                        <p class="font-medium leading-5 truncate text-gray-500">
                            {{'preferred.timezone' | translate}} </p>
                        <p class="mt-1 text-gray-900 text-wrap">
                            {{customerDetails.customer_timezone_value}}</p>
                        </div>
                        <div *ngIf="customerDetails.customer_contact_no?.home"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer customer-details-fields dark:bg-hover flex-item-wrap">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'home' | translate}}
                            </p>
                            <p class="mt-1 text-gray-900">
                                <a href="tel:{{customerDetails.customer_contact_no.home}}">
                                    {{customerDetails.customer_contact_no.home}}
                                </a>
                            </p>
                        </div>
                        <div *ngIf="customerDetails.customer_contact_no?.work"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer customer-details-fields dark:bg-hover flex-item-wrap">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'text.work' | translate}}
                            </p>
                            <p class="mt-1 text-gray-900">
                                <a href="tel:{{customerDetails.customer_contact_no.work}}">
                                    {{customerDetails.customer_contact_no.work}}
                                </a>
                            </p>
                        </div>
                        <div *ngIf="customerDetails.customer_contact_no?.mobile"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer customer-details-fields dark:bg-hover flex-item-wrap">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'text.mobile' | translate}} </p>
                            <p class="mt-1 text-gray-900">
                                <a href="tel:{{customerDetails.customer_contact_no.mobile}}">
                                    {{customerDetails.customer_contact_no.mobile}}
                                </a>
                            </p>
                        </div>
                        <div *ngIf="customerDetails.created_at"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer customer-details-fields dark:bg-hover flex-item-wrap">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'created.at.text' | translate}} </p>
                            <p class="mt-1 text-gray-900">
                                {{customerDetails.created_at | datetime}}</p>
                        </div>
                        <div
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer customer-details-fields dark:bg-hover flex-item-wrap">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'status.text' | translate}} </p>
                            <div class="mt-2">
                                <badge [options]="getStatusBadgeOptions(customerDetails.is_active ? 'ACTIVE' : 'INACTIVE', (customerDetails.is_active ? 'active.text' :
                                                            'text.inactive')
                                                            |
                                                            translate)">
                                </badge>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="customerDetails.customer_tags && customerDetails.customer_tags.length"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-4 cursor-pointer customer-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500 text-base">
                        {{'text.customer_tags' | translate}} </p>
                    <div class="flex flex-wrap">
                        <div *ngFor="let tag of customerDetails.customer_tags"
                            class="flex items-center justify-center py-1 px-3 mr-3 mb-3 rounded-full leading-normal text-gray-500 bg-gray-200 dark:text-gray-300 dark:bg-gray-700 ng-star-inserted">
                            <span class="text-sm font-medium whitespace-nowrap">{{tag}}</span>
                        </div>
                    </div>
                </div>
                <div class="px-2 py-2 border-t text-base"
                    *ngIf="customerDetails.customer_address && (customerDetails.customer_address.street || customerDetails.customer_address.state)">
                    <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                        {{'text.customer_address' | translate}} </p>
                    <div class="px-3">
                        <p *ngIf="customerDetails.customer_address.first_name" class="text-base mb-2">
                            {{customerDetails.customer_address.first_name}}
                            {{customerDetails.customer_address.last_name}}</p>
                        <p *ngIf="customerDetails.customer_address.street" class="text-base mb-2">
                            {{customerDetails.customer_address.street}}</p>
                        <p *ngIf="customerDetails.customer_address.landmark" class="text-base mb-2">
                            {{customerDetails.customer_address.landmark}}</p>
                        <p *ngIf="customerDetails.customer_address.city" class="text-base mb-2">
                            {{customerDetails.customer_address.city}}</p>
                        <p *ngIf="customerDetails.customer_address.state" class="text-base mb-2">
                            {{customerDetails.customer_address.state}}
                            {{customerDetails.customer_address.zip_code ? '- ' +
                            customerDetails.customer_address.zip_code : '' }}</p>
                        <p *ngIf="customerDetails.customer_address.country" class="text-base">
                            {{customerDetails.customer_address.country}}</p>
                    </div>
                </div>
                <div class="px-2 py-2 border-t text-base"
                    *ngIf="customerDetails.customer_billing_address && (customerDetails.customer_billing_address.street || customerDetails.customer_billing_address.state)">
                    <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                        {{'billing.address.text' | translate}} </p>
                    <div class="px-3">
                        <p *ngIf="customerDetails.customer_billing_address.first_name" class="text-base mb-2">
                            {{customerDetails.customer_billing_address.first_name}}
                            {{customerDetails.customer_billing_address.last_name}}</p>
                        <p *ngIf="customerDetails.customer_billing_address.street" class="text-base mb-2">
                            {{customerDetails.customer_billing_address.street}}</p>
                        <p *ngIf="customerDetails.customer_billing_address.landmark" class="text-base mb-2">
                            {{customerDetails.customer_billing_address.landmark}}</p>
                        <p *ngIf="customerDetails.customer_billing_address.city" class="text-base mb-2">
                            {{customerDetails.customer_billing_address.city}}</p>
                        <p *ngIf="customerDetails.customer_billing_address.state" class="text-base mb-2">
                            {{customerDetails.customer_billing_address.state}}
                            {{customerDetails.customer_billing_address.zip_code ? '- ' +
                            customerDetails.customer_billing_address.zip_code : '' }}</p>
                        <p *ngIf="customerDetails.customer_billing_address.country" class="text-base">
                            {{customerDetails.customer_billing_address.country}}</p>
                    </div>
                </div>
            </div>
        </div>
    </li>
</ul>
<div *ngIf="isMaxSelectionLimit">
    <div class="rounded-md bg-gray-200 px-4 py-3">
        <div class="flex">
            <div class="flex-shrink-0">
            <i class="ti ti-alert-circle text-red-700 text-2xl"></i>
            </div>
            <div class="ml-3 flex-1 md:flex md:justify-between">
            <p class="text-base text-red-700">{{"alert.max_count_selected" | translate}}</p>
            </div>
        </div>
    </div>
</div>

<div class="overflow-hidden data-picker-list-content-height flex flex-col items-center justify-center"
    *ngIf="!customers.length && loaded && !showSelectedItems">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_customer_found.svg" alt="No Customers Found">
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="onSearch">{{'dataPicker.customer.not_found' | translate}}
            '{{searchKey}}'</h4>
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="!onSearch">{{'dataPicker.customer.placeholder' | translate}}
        </h4>
    </div>
</div>